import { ApIcon } from '@alixpartners/ui-components';
import './ExhibitErrorMessage.css';

export const ExhibitErrorMessage = (props: { text: string }) => (
  <div className="exhibit-warning-message">
    <ApIcon iconName="error" iconColor="red" />
    {props.text}
  </div>
);
